export interface NewsArticle {
  id: string;
  title: string;
  publishedAt: string;
  category: string;
  summary: string;
  cover: string;
  tags: string[];
  content: string[];
}

export const news: NewsArticle[] = [
  {
    id: "n01",
    title: "2025年华语电影市场年度盘点：票房与口碑双丰收",
    publishedAt: "2025-10-08",
    category: "行业观察",
    summary: "过去一年华语电影在题材创新与工业化水准上取得显著突破，多部作品实现票房与口碑的双赢。",
    cover:
      "https://readdy.ai/api/search-image?query=cinema%20hall%20with%20rows%20of%20red%20seats%20and%20a%20glowing%20screen%2C%20deep%20blue%20ambient%20lighting%20with%20warm%20orange%20accents%2C%20cinematic%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-01-cover&orientation=landscape",
    tags: ["票房", "年度盘点", "市场"],
    content: [
      "回顾过去一年，华语电影市场呈现出明显的回暖态势。无论是暑期档还是国庆档，都涌现出一批兼具商业价值与艺术追求的优秀作品。观众对于高质量内容的付费意愿持续提升，为行业注入了强劲的信心。",
      "从题材上看，科幻、悬疑与现实题材成为三大热门方向。多部作品在类型融合上进行大胆尝试，将本土文化元素与国际化叙事相结合，获得了海内外观众的广泛认可。",
      "业内人士指出，随着制作水准的整体提升和观众审美的日益成熟，华语电影正逐步从依赖流量转向内容驱动的良性发展轨道。未来，如何在全球化竞争中讲好本土故事，将成为行业持续探索的核心命题。",
    ],
  },
  {
    id: "n02",
    title: "《星际迷航：归途》续集正式官宣，主创团队悉数回归",
    publishedAt: "2025-10-05",
    category: "影视动态",
    summary: "片方宣布《星际迷航：归途》续集已进入前期筹备，导演与核心演员阵容将原班回归。",
    cover:
      "https://readdy.ai/api/search-image?query=spaceship%20model%20on%20a%20press%20conference%20stage%20with%20blue%20and%20orange%20spotlights%2C%20cinematic%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-02-cover&orientation=landscape",
    tags: ["续集", "官宣", "科幻"],
    content: [
      "在刚刚结束的发布会上，片方正式宣布《星际迷航：归途》的续集已启动前期筹备工作。导演与编剧团队将原班回归，主演阵容也已基本敲定。",
      "据透露，续集将继续围绕深空探索的主题展开，但在叙事规模上会有更大突破。制片人表示，团队希望在保留前作情感内核的同时，探索更加宏大的宇宙世界观。",
      "影片预计将于明年正式开机，具体上映档期尚未公布。消息一出，迅速登上各大社交平台热搜，粉丝们纷纷表达期待。",
    ],
  },
  {
    id: "n03",
    title: "第37届金梧桐奖提名名单公布，现实题材作品表现亮眼",
    publishedAt: "2025-10-02",
    category: "奖项",
    summary: "本届金梧桐奖提名名单揭晓，多部现实题材作品入围主要奖项，展现了行业的创作活力。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20film%20award%20trophy%20on%20a%20stage%20with%20blue%20and%20orange%20lighting%2C%20cinematic%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-03-cover&orientation=landscape",
    tags: ["奖项", "提名", "现实题材"],
    content: [
      "第37届金梧桐奖组委会正式公布了本年度提名名单。在最受关注的最佳影片单元中，多部现实题材作品凭借扎实的剧本与真挚的情感表达成功入围。",
      "评委会表示，今年的参评作品整体质量较高，创作者们更加关注普通人的生活与情感，用镜头记录时代变迁。这种创作导向值得肯定。",
      "颁奖典礼将于下月举行，最终获奖名单届时揭晓。",
    ],
  },
  {
    id: "n04",
    title: "网络剧精品化趋势明显，精品短剧集成为市场新宠",
    publishedAt: "2025-09-28",
    category: "行业观察",
    summary: "越来越多的平台将资源投向短小精悍的剧集，网络剧的整体品质与口碑稳步提升。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20streaming%20studio%20set%20with%20cameras%20and%20monitors%2C%20blue%20and%20orange%20lighting%2C%20cinematic%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-04-cover&orientation=landscape",
    tags: ["网络剧", "短剧", "精品化"],
    content: [
      "近年来，网络剧市场呈现出明显的精品化趋势。与过去动辄数十集的长篇剧集不同，节奏紧凑、制作精良的短剧集越来越受到观众青睐。",
      "业内分析认为，短剧集的走红反映了观众观看习惯的变化。在碎片化时代，能够在有限篇幅内讲好完整故事的作品，更容易获得高完成度和好口碑。",
      "多个平台表示，未来将继续加大对优质短剧集的投资力度，推动行业向更高质量的方向发展。",
    ],
  },
  {
    id: "n05",
    title: "影视行业迎来AI制作时代，技术革新引发广泛热议",
    publishedAt: "2025-09-22",
    category: "科技前沿",
    summary: "AI技术在影视制作全流程的应用不断深化，从剧本策划到后期特效，效率与创意边界同时被改写。",
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20digital%20editing%20suite%20with%20holographic%20screens%2C%20deep%20blue%20and%20orange%20glow%2C%20cinematic%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-05-cover&orientation=landscape",
    tags: ["AI", "技术", "特效"],
    content: [
      "人工智能正在以前所未有的速度渗透进影视制作的各个环节。从剧本辅助创作、分镜生成，到后期特效渲染与配音合成，AI工具的介入显著提升了制作效率。",
      "不过，技术革新也引发了行业内的广泛讨论。有创作者担心AI可能削弱作品的原创性，也有人认为善用工具能够把创作者从繁琐的重复劳动中解放出来，专注于创意本身。",
      "多数从业者的共识是：技术只是手段，打动人心的始终是好的故事与真挚的情感。",
    ],
  },
  {
    id: "n06",
    title: "《长安十二时》口碑爆棚，古装悬疑再掀收视热潮",
    publishedAt: "2025-09-15",
    category: "影视动态",
    summary: "古装悬疑剧《长安十二时》凭借精良的制作与紧凑的叙事收获高口碑，引发追剧热潮。",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20street%20at%20night%20with%20glowing%20lanterns%2C%20deep%20blue%20sky%20and%20warm%20orange%20lights%2C%20cinematic%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-06-cover&orientation=landscape",
    tags: ["古装", "悬疑", "口碑"],
    content: [
      "自开播以来，《长安十二时》凭借扎实的剧本、考究的服化道和张力十足的叙事节奏，迅速成为讨论度最高的剧集之一。多条剧情线索交织推进，让观众欲罢不能。",
      "剧中对历史细节的还原和对人物群像的塑造，获得了不少历史爱好者的认可。有评论认为，该剧为古装悬疑这一类型树立了新的标杆。",
      "随着剧情进入高潮，相关话题多次登上热搜榜，追剧热潮仍在持续。",
    ],
  },
  {
    id: "n07",
    title: "国际电影节落幕，华语影片斩获三项大奖",
    publishedAt: "2025-09-08",
    category: "奖项",
    summary: "在本届国际电影节上，多部华语影片入围主竞赛单元，最终斩获三项重要奖项。",
    cover:
      "https://readdy.ai/api/search-image?query=international%20film%20festival%20red%20carpet%20at%20night%20with%20blue%20and%20orange%20lighting%2C%20cinematic%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-07-cover&orientation=landscape",
    tags: ["电影节", "获奖", "国际"],
    content: [
      "本届国际电影节闭幕式上，多部华语影片表现亮眼，分别在最佳导演、最佳摄影和评审团特别奖三个单元中获奖。",
      "评委在颁奖词中称赞这些作品'以细腻的东方视角呈现了普世的情感'，展现了华语电影在国际舞台上的独特魅力。",
      "多位获奖者在感言中表示，会继续坚持创作，用影像讲述更多动人的故事。",
    ],
  },
  {
    id: "n08",
    title: "流媒体平台加大自制内容投入，内容竞争进入白热化",
    publishedAt: "2025-08-30",
    category: "行业观察",
    summary: "各大流媒体平台持续加码原创内容，差异化布局成为竞争关键。",
    cover:
      "https://readdy.ai/api/search-image?query=server%20room%20with%20glowing%20blue%20and%20orange%20indicator%20lights%2C%20cinematic%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-08-cover&orientation=landscape",
    tags: ["流媒体", "原创", "竞争"],
    content: [
      "随着用户增长趋于平稳，各大流媒体平台纷纷将重心转向原创内容的投入。独家首播、高质量自制剧集成为吸引和留住用户的核心手段。",
      "从布局上看，平台之间的差异化日益明显：有的深耕悬疑类型，有的主打合家欢内容，还有的专注于纪录与人文题材。",
      "分析人士认为，内容竞争的白热化对观众而言是利好，将有更多优质作品涌现。",
    ],
  },
];